var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('h3',{staticClass:"title"},[_vm._v("401")]),_c('p',{staticClass:"desc"},[_vm._v("Unauthorized error!")]),_c('p',{staticClass:"desc"},[_vm._v("Account is not authorized to access this page.")])])
}]

export { render, staticRenderFns }